import React, { useContext } from 'react';
import './Header.scss';
import getText from '../../assets/locale/locale';
import LocaleContext from '../../contexts/LocaleContext';
import addDataLayerTrigger from '../../utils/addDataLayerTrigger/addDataLayerTrigger';

/**
 * Header is the top header bar consistent across all screens
 */
const Header = () => {
  const locId = useContext(LocaleContext);

  return (
    <header className="vp-header" data-testid="header">
      <div className="jonesLogoContainer">
        <a
          href={getText(locId, 'link', 'header')}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => addDataLayerTrigger('edward_jones_click', {})}
          data-testid="edward-jones-link"
        >
          <div className="jonesLogo"><img src="/public/images/ej-logo.png" alt="Edward Jones" /></div>
        </a>
      </div>
      <div className="heading">
        <p>{getText(locId, 'title', 'header')}</p>
      </div>
    </header>
  );
};

export default Header;